import { Options, Vue } from 'vue-class-component'
import { useRoute } from 'vue-router'
import BaseFunctions from '@/components/Utility/Base'
import { Posts } from '@/services/PostsDataService'
import SysPost, { SysPostCategory, SysPostVersion } from '@/types/SysPost'
import SimpleCalendar from '@/components/Frontend/SimpleCalendar/index.vue'
import LeftSideBar from '@/components/Frontend/LeftSideBar/index.vue'
import { watch } from 'vue'
import { Watch } from 'vue-property-decorator'

type postDataType = { postStatus: boolean; postTitle: string; postContents: string; postReleased: string; postCategory: string; postViews: number; postId: number; postAuthorName: string; postLiked: [] }
type dataReturnType = { error: any; }

@Options({
  props: {
    instanceType: Number
  },
  components: {
    SimpleCalendar,
    LeftSideBar
  }
})
export default class News extends Vue {
  instanceType!: number
  error: any = null
  showData: any = false
  private tempPost = {} as SysPost
  postData: postDataType = { postStatus: true, postTitle: '', postContents: '', postReleased: '', postCategory: '', postViews: 0, postId: 0, postAuthorName: '', postLiked: [] }

  readonly name : string = 'News'
  data (): dataReturnType {
    return {
      error: this.error
    }
  }

  public getBreadcrumbs (): Record<string, string>[] {
    const route = useRoute()
    const fullPath = route.path
    const segments = fullPath.split('/').filter(seg => seg)

    const breadcrumbs = segments.map((seg, index) => {
      return {
        name: seg.charAt(0).toUpperCase() + seg.slice(1),
        path: '/' + segments.slice(0, index + 1).join('/')
      }
    })

    return [...breadcrumbs]
  }

  public getIndexOfPostVersion (postVersion: number, singlePostEntryObj: SysPost = this.tempPost) : number {
    // const retVal = this.indlaegs.indlaeg_versionerings_id.findIndex(x => x.indlaeg_versionering_version === postVersion)
    const retVal = singlePostEntryObj.indlaeg_versionerings_id?.findIndex(x => x.indlaeg_versionering_version === postVersion)
    // console.log('Index of post version = ' + retVal + ' ; post versioning object = ' + JSON.stringify(singlePostEntryObj.indlaeg_versionerings_id))

    return (retVal === undefined ? -1 : retVal)
  }

  public convertHTMLToText (htmlData: string) : string {
    return BaseFunctions.convertHTMLToText(htmlData)
  }

  relatedPosts = []

  public async relatedPost () {
    try {
      const response = await Posts.PostsDataService.getPopulatedData()

      const category = this.route.fullPath.split('/')[1].toLowerCase()
      const currentSlug = this.route.fullPath.split('/')[2].toLowerCase()

      // Step 1: Get all posts in the same category (INCLUDING current post)
      const allRelatedPost = response.data.filter((item: any) =>
        item?.indlaeg_kategori_id?.indlaeg_kategori_titel?.toLowerCase() === category
      )

      // Step 2: Find previous and next post using full list
      this.adjacentPosts(allRelatedPost, currentSlug)

      // Step 3: Related posts (excluding current one, max 3)
      this.relatedPosts = allRelatedPost
        .filter((item: any) =>
          item.indlaeg_slug?.toLowerCase() !== currentSlug
        )
        .slice(0, 3)
    } catch (err) {
      console.log(err)
    }
  }

  previousPost = null
  nextPost = null

  public adjacentPosts (data: any[], currentSlug: string) {
    const currentIndex = data.findIndex((item: any) =>
      item.indlaeg_slug?.toLowerCase() === currentSlug
    )

    if (currentIndex !== -1) {
      this.previousPost = currentIndex > 0 ? data[currentIndex - 1] : null
      this.nextPost = currentIndex < data.length - 1 ? data[currentIndex + 1] : null
    } else {
      this.previousPost = null
      this.nextPost = null
    }
  }

  public home () : void {
    this.$router.push('/')
  }

  goToAuthorPosts (authorName: string) {
    this.$router.push({
      name: 'Author',
      params: { author_name: authorName }
    })
  }

  public viewPostById (item: any) {
    console.log(item, 'item >>>>>>>>>>')
    if (!item) return
    this.$router.push({
      name: 'Indlaeg_type',
      params: { indlaeg_type: item?.indlaeg_kategori_id?.indlaeg_kategori_titel, indlaegSlug: item.indlaeg_slug }
    })
  }

  extractImgUrl (content: any) {
    const html = content?.indlaeg_versionerings_id?.[content?.indlaeg_versionerings_id.length - 1]?.indlaeg_versionering_indhold ?? ''
    const urls = new Set()

    const combinedRegex = /<img[^>]+src=["']([^"']+\.(?:jpg|jpeg|png|gif|webp|svg))["']|https?:\/\/[^\s"'<>]+?\.(?:jpg|jpeg|png|gif|webp|svg)/gi
    let match

    while ((match = combinedRegex.exec(html)) !== null) {
      urls.add(match[1] || match[0])
    }
    const res = Array.from(urls)[0]
    return res
  }

  route = useRoute()

  public retrieveNewsItem () : void {
    // const route = useRoute()
    const postSlug = this.route.params.indlaegSlug

    Posts.PostsDataService.getBySlug(postSlug.toString())
      .then((response) => {
        this.tempPost = response.data[0]
        this.postData = {
          postStatus: this.tempPost.indlaeg_status,
          postTitle: this.tempPost.indlaeg_versionerings_id[this.getIndexOfPostVersion(this.tempPost.indlaeg_version)]?.indlaeg_versionering_titel,
          postContents: this.tempPost.indlaeg_versionerings_id[this.getIndexOfPostVersion(this.tempPost.indlaeg_version)]?.indlaeg_versionering_indhold,
          postReleased: new Date(this.tempPost.indlaeg_udgivet).toLocaleDateString('da-DK'),
          postCategory: this.tempPost?.indlaeg_kategori_id?.indlaeg_kategori_titel,
          postViews: Number(this.tempPost?.indlaeg_visninger),
          postId: Number(this.tempPost?.id),
          postLiked: this.tempPost?.indlaeg_likes,
          postAuthorName: this.tempPost?.indlaeg_forfatter?.firstname + ' ' + this.tempPost?.indlaeg_forfatter?.lastname
        }
        this.showData = true
        this.postData.postViews += 1
        const updatePostsData = {
          indlaeg_visninger: this.postData.postViews
        }
        this.isLiked = this.tempPost?.indlaeg_likes.length > 0 ? true : false
        this.likesCount(this.postData.postId)

        this.styleDynamicHtml()

        Posts.PostsDataService.update(this.postData.postId.toString(), updatePostsData)
          .then((response) => {
            console.log(response.data)
          })
          .catch((err) => {
            console.log(' error', err)
            this.error = err
          })
      })
      .catch((err) => {
        console.log('inside error', err)
        this.error = err
      })
  }

  styleDynamicHtml () {
    setTimeout(() => {
      const container = this.$el.querySelector('.v-html-container')
      if (container) {
        console.log('CONTAINER', container)
        container.querySelectorAll('img').forEach((img: HTMLElement) => {
          img.style.setProperty('max-width', '100%', 'important')
          img.style.setProperty('height', 'auto', 'important')
          img.style.setProperty('display', 'block', 'important')
          img.style.setProperty('object-fit', 'contain', 'important')
        })
      }
    })
  }

  isLiked = false
  likeCount = 0

  public handleLikes (id: any) {
    Posts.PostsDataService.like(id).then((res) => {
      this.isLiked = res.data.liked
      this.likesCount(id)
    })
  }

  public likesCount (id: any) {
    Posts.PostsDataService.likeCount(id).then((res) => {
      console.log(res, 'res.data')
      this.likeCount = typeof res.data === 'object' ? res.data.data : res.data
    })
  }

  @Watch('$route')
  onRouteChange (newRoute: any, oldRoute: any) {
    this.$nextTick(() => {
      if (newRoute && newRoute.params) {
        this.retrieveNewsItem()
        this.relatedPost()
      } else {
        console.warn('Route params not available yet.')
      }
    })
  }

  @Watch('$route.params')
  onRouteParamsChange (newRoute: any, oldRoute: any) {
    this.$nextTick(() => {
      if (newRoute && newRoute.params) {
        this.retrieveNewsItem()
        this.relatedPost()
      } else {
        console.warn('Route params not available yet.')
      }
    })
  }

  async mounted () : Promise<void> {
    this.retrieveNewsItem()
    this.relatedPost()
  }
}
